export const GET_OCTORATE_RESERVATIONS = "[OCTORATE_RESERVATIONS] Get Octorate Reservations";
export const GET_OCTORATE_RESERVATIONS_SUCCESS = "[OCTORATE_RESERVATIONS] Get Octorate Reservations Success";
export const GET_OCTORATE_RESERVATIONS_FAIL = "[OCTORATE_RESERVATIONS] Get Octorate Reservations Fail";

export const IMPORT_OCTORATE_RESERVATIONS = "[OCTORATE_RESERVATIONS] Import Octorate Reservations";
export const IMPORT_OCTORATE_RESERVATIONS_SUCCESS = "[OCTORATE_RESERVATIONS] Import Octorate Reservations Success";
export const IMPORT_OCTORATE_RESERVATIONS_FAIL = "[OCTORATE_RESERVATIONS] Import Octorate Reservations Fail";